<template>
  <div>
    <ul v-show="!mobile" class="navigation-list">
      <li>
        <router-link
          :to="{ name: 'technology' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.name === 'technology' }"
          >{{ $t('technology') }}</router-link
        >
      </li>

      <li>
        <router-link
          :to="{ name: 'ecosystem' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.name === 'ecosystem' }"
          >{{ $t('ecosystem') }}</router-link
        >
      </li>

      <li>
        <router-link
          :to="{ name: 'community' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.name === 'community' }"
          >{{ $t('community') }}</router-link
        >
      </li>

      <li>
        <router-link
          :to="{ name: 'explorer' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.path.startsWith('/explorer') }"
          >{{ $t('explorer') }}</router-link
        >
      </li>

      <li>
        <router-link
          :to="{ name: 'news' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.name === 'news' }"
          >{{ $t('news') }}</router-link
        >
      </li>

      <li>
        <router-link
          :to="{ name: 'help' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.name === 'help' }"
          >{{ $t('help') }}</router-link
        >
      </li>
      <li>
        <router-link
          :to="{ name: 'gameManager', params: { id: 5 } }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.path.startsWith('/gameDetails') }"
        >
          {{ $t('games') }}
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'travelPage' }"
          class="nav-item"
          :class="{ 'active-nav-item': $route.name === 'travelPage' }"
        >
          {{ $t('travel') }}
        </router-link>
      </li>
    </ul>

    <div class="icon">
      <div
        @click="toggleMobleNav"
        v-show="mobile"
        class="burger"
        :class="{ 'icon-active': mobileNav }"
      >
        <img :src="BurgerSource" alt="burger" />
      </div>
      <transition name="fade">
        <div
          v-show="mobileNav"
          class="overlay-mask"
          @click="toggleMobleNav"
        ></div>
      </transition>

      <transition name="mobile-nav">
        <div
          class="mob-navigation-mask"
          @click="toggleMobleNav"
          v-show="mobileNav"
        >
          <div class="dropdown-menu" @click.stop="">
            <div class="mob-mode">
              <ModeSelector></ModeSelector>
            </div>
            <div class="mob-menu">
              <ul>
                <li>
                  <router-link
                    :to="{ name: 'home' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'home' }"
                    @click.native="closeMobileMenu"
                    >{{ $t('home') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'technology' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'technology' }"
                    @click.native="closeMobileMenu"
                    >{{ $t('technology') }}</router-link
                  >
                </li>

                <li>
                  <router-link
                    :to="{ name: 'ecosystem' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'ecosystem' }"
                    @click.native="closeMobileMenu"
                    >{{ $t('ecosystem') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'community' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'community' }"
                    @click.native="closeMobileMenu"
                    >{{ $t('community') }}</router-link
                  >
                </li>

                <li>
                  <router-link
                    :to="{ name: 'explorer' }"
                    class="nav-mob-item"
                    :class="{
                      'active-nav-item': $route.path.startsWith('/explorer')
                    }"
                    @click.native="closeMobileMenu"
                    >{{ $t('explorer') }}</router-link
                  >
                </li>

                <li>
                  <router-link
                    :to="{ name: 'news' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'news' }"
                    @click.native="closeMobileMenu"
                    >{{ $t('news') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'help' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'help' }"
                    @click.native="closeMobileMenu"
                    >{{ $t('help') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'gameManager', params: { id: 5 } }"
                    class="nav-mob-item"
                    :class="{
                      'active-nav-item': $route.path.startsWith('/gameDetails')
                    }"
                    @click.native="closeMobileMenu"
                  >
                    {{ $t('games') }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'travelPage' }"
                    class="nav-mob-item"
                    :class="{ 'active-nav-item': $route.name === 'travelPage' }"
                    @click.native="closeMobileMenu"
                  >
                    {{ $t('travel') }}
                  </router-link>
                </li>
              </ul>
              <div class="mob-lang">
                <LangSelector></LangSelector>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import useDarkMode from '@/darkMode'
import ModeSelector from '@/components/common/modeSelector.vue'
import LangSelector from '@/components/common/langSelector.vue'
export default {
  name: 'HeaderNavList',
  props: ['currentRoute'],
  components: {
    LangSelector,
    ModeSelector
  },
  data () {
    return {
      mobile: null,
      mobileNav: null,
      windowWidth: null,
      ecosystemSubmenu: false,
      communitySubmenu: false,
      scrollPosition: 0
    }
  },
  setup () {
    const { isDark } = useDarkMode()
    return {
      isDark
    }
  },
  computed: {
    BurgerSource () {
      return this.isDark
        ? '/images/icons/burger-icon-dark.svg'
        : '/images/icons/burger-icon.svg'
    }
  },
  created () {
    window.addEventListener('resize', this.checkScreen)
    this.checkScreen()
  },
  watch: {
    $route (to, from) {
      this.mobileNav = false

      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''

      window.scrollTo(0, 0)
    }
  },
  methods: {
    toggleMobleNav () {
      this.mobileNav = !this.mobileNav
      if (this.mobileNav) {
        this.scrollPosition =
          window.pageYOffset || document.documentElement.scrollTop
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this.scrollPosition}px`
        document.body.style.width = '100%'
      } else {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.width = ''
        window.scrollTo(0, this.scrollPosition)
      }
    },
    closeMobileMenu () {
      this.mobileNav = false
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
    },
    checkScreen () {
      this.windowWidth = window.innerWidth
      if (this.windowWidth <= 1150) {
        this.mobile = true
        return
      }
      this.mobileNav = false
      this.mobile = false
      return
    }
  }
}
</script>
